/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
// libraries
import React from 'react';
import { Query } from 'react-apollo';
import { connect } from 'react-redux';
import gql from 'graphql-tag';
import { object, string } from 'prop-types';
import mbpLogger from 'mbp-logger';
import { compose } from 'recompose';
import { GRAPHQL_ENV } from '../../../gql';

import { coreBrowsingPageViewSuccessTest } from '../../../helpers/tracking/common/commonTrackingHelpers';
import withPageView from '../../../helpers/tracking/hocs/withPageView';
import GraphqlMasterTemplatePageBody from './GraphqlMasterTemplatePageBody';

import { getPresentationFamily, getFeatureFlags } from '../../../../state/ducks/App/ducks/Config/Config-Selectors';
import { getBrand } from '../../../../state/ducks/App/ducks/Brand/Brand-Selectors';
import { getSSRDeviceType } from '../../../../state/ducks/App/App-Selectors';
import { setLocale } from '../../../../state/ducks/Member/ducks/Auth/helper/helper';

const GraphqlMasterTemplatePage = ({
    brand, page, ssrDeviceType, presentationFamily, featureFlags,
}) => {
    const CONNECTION_COMMUNITIES_QUERY = gql`
    query MasterTemplatePageQuery {
        findContentPage(brand: "${brand['domain-name']}", environment: "${GRAPHQL_ENV}", url: "${page.path}", contentType: "${page.contentType}", locale: "${setLocale()}") {
            content
        }
    }`;

    return (
        <Query query={CONNECTION_COMMUNITIES_QUERY}>
            {({ loading, error, data }) => {
                if (loading) {
                    return <div style={{ height: '80vh' }} />; // prevent header and footer from snapping together
                }
                if (error) {
                    mbpLogger.logError({
                        query: CONNECTION_COMMUNITIES_QUERY,
                        component: 'GraphqlMasterTemplatePage.js',
                        message: 'Error loading data from Graphql',
                        env: GRAPHQL_ENV,
                        error,
                    });
                    return null;
                }
                if (!data) {
                    mbpLogger.logWarning({
                        query: CONNECTION_COMMUNITIES_QUERY,
                        component: 'GraphqlMasterTemplatePage.js',
                        message: 'No data returned for query',
                        env: GRAPHQL_ENV,
                    });
                    return null;
                }
                if (!data?.findContentPage?.content) {
                    mbpLogger.logWarning({
                        query: CONNECTION_COMMUNITIES_QUERY,
                        component: 'GraphqlMasterTemplatePage.js',
                        message: 'No content returned for query',
                        env: GRAPHQL_ENV,
                    });
                    return null;
                }
                if (data) {
                    const masterTemplateBlocks = data?.findContentPage?.content?.entries?.[0]?.modular_blocks || null;
                    const SEO = data?.findContentPage?.content?.entries?.[0]?.seo || {};
                    const domainURL = `https://www.${brand.domain}.com` || '';
                    const code = data?.findContentPage?.content?.entries?.[0]?.code || '';
                    mbpLogger.logInfo({
                        message: 'data returned from HomePageQuery',
                    });

                    return (
                        <GraphqlMasterTemplatePageBody
                            brand={brand}
                            page={page}
                            blocks={masterTemplateBlocks}
                            seo={SEO}
                            code={code}
                            domainURL={domainURL}
                            ssrDeviceType={ssrDeviceType}
                            presentationFamily={presentationFamily}
                            featureFlags={featureFlags}
                        />
                    );
                }

                return <>No MasterTempatepage</>;
            }}
        </Query>
    );
};

GraphqlMasterTemplatePage.propTypes = {
    brand: object.isRequired,
    page: object.isRequired,
    ssrDeviceType: string.isRequired,
    presentationFamily: string.isRequired,
    featureFlags: object.isRequired,
};

const mapStateToProps = (state) => ({
    brand: getBrand(state),
    ssrDeviceType: getSSRDeviceType(state),
    presentationFamily: getPresentationFamily(state),
    featureFlags: getFeatureFlags(state),
});
const enhance = compose(
    withPageView({
        pageViewSuccessTest: coreBrowsingPageViewSuccessTest,
    }),
    connect(mapStateToProps),
);

export default enhance(GraphqlMasterTemplatePage);
